import System from "../helper/system";


export function useSystem() {
  return [
    {},
    {
      get_quantity_format: (quantity) => {
        const qtyNum = Number(quantity);
        return qtyNum ? (System.getFormatNumber({ amount: qtyNum, maximumFractionDigits: 0, isSymbol: false, isDisplaySymbol: false }) || 0) : quantity;
      },
    },
    {}
  ];
}